import { buildUrl } from 'app/router/helpers/buildUrl';

const TERMS_URL = buildUrl('/tos');
const GAMEPASS_PROMOTION_TERMS_CONDITIONS_URL = buildUrl(
  '/gamepass-promotion-terms-conditions',
);
const RESETPW_URL = buildUrl('/resetpw');
const PRIVACY_URL = buildUrl('/privacy');
const HOME_URL = buildUrl('/');
const CONTACT_US_URL = buildUrl('/help?topic=contact');
const LOGIN_URL = buildUrl('/login');
const QUEUE_URL = buildUrl('/queue');
const NEWS_URL = buildUrl('/news');
const ACCOUNT_MEMBERSHIP_URL = buildUrl('/acct/membership');
const GENDER_EQUALITY_URL = buildUrl('/gender-equality-index/index.html');
const PRIVACY_PORTAL_URL =
  'https://privacyportal-cdn.onetrust.com/dsarwebform/d19e506f-1a64-463d-94e4-914dd635817d/b9eb997c-9ede-451b-8fd4-29891782a928.html';
const ADCHOICES_URL =
  'https://www.sonypictures.com/corp/privacy.html#section11B';
const TRANSPARENCY_STATEMENT_URL =
  'https://www.sonypictures.com/corp/pdfs/modern_slavery_transparency_statement.pdf';

export {
  TERMS_URL,
  GAMEPASS_PROMOTION_TERMS_CONDITIONS_URL,
  RESETPW_URL,
  PRIVACY_URL,
  HOME_URL,
  CONTACT_US_URL,
  LOGIN_URL,
  QUEUE_URL,
  NEWS_URL,
  ACCOUNT_MEMBERSHIP_URL,
  GENDER_EQUALITY_URL,
  PRIVACY_PORTAL_URL,
  ADCHOICES_URL,
  TRANSPARENCY_STATEMENT_URL,
};
